import { FieldError, FieldErrors } from 'react-hook-form'

import { useFormTranslations } from '@maestro/commerce-blocks/hooks/use-form-translations'

export function getTranslatedFormErrors(
  errors: FieldErrors,
  formT: ReturnType<typeof useFormTranslations>
): FieldErrors {
  return Object.keys(errors).reduce(
    (acc: FieldErrors, fieldName: keyof FieldErrors) => {
      const error = errors[fieldName]

      if (typeof error?.message === 'string' && fieldName !== 'root') {
        try {
          const parsedMessage = JSON.parse(error.message)

          if (parsedMessage?.path) {
            const { path, ...rest } = parsedMessage
            acc[fieldName] = {
              ...error,
              message: formT(`validation.${path}`, rest),
            } as FieldError
          } else {
            acc[fieldName] = error
          }
        } catch {
          acc[fieldName] = error
        }
      } else if (
        typeof error === 'object' &&
        Object.keys(error).some((key) =>
          isFieldError(error[key as keyof typeof error])
        )
      ) {
        acc[fieldName] = getTranslatedFormErrors(error as FieldErrors, formT)
      } else {
        acc[fieldName] = error!
      }

      return acc
    },
    {}
  )
}

function isFieldError(error: unknown): error is FieldError {
  return (typeof error === 'object' &&
    error !== null &&
    'message' in error) as boolean
}
